import React from 'react';
import MassEditModal from '../mass-edit-modal';
import { Form } from 'react-bootstrap';
import { useEditor } from '../mass-edit-modals';
import Selector from '../../locations/selector'

export default () => {
    const editor = useEditor({
        getInitialValue: ({ locationId }) => ({ locationId }),
    })

    return (
        <MassEditModal
            title={`Edit ${editor.experiences.length} Locations`}
            onCancel={editor.onClose}
            onSave={editor.save}
            disabled={!editor.value.locationId}
            busy={editor.isBusy}
        >
            <Form.Group>
                <Form.Label>Location</Form.Label>
                <Selector value={editor.value.locationId} onChange={(locationId) => editor.setValue({ locationId })} />
            </Form.Group>
        </MassEditModal>
    );
};
